import { render, staticRenderFns } from "./RemanejarValor.vue?vue&type=template&id=a9b2971a"
import script from "./RemanejarValor.vue?vue&type=script&lang=js"
export * from "./RemanejarValor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports